import React, { useEffect, useState } from "react";
import BookingCard from "./BookingCard";
import { api } from "../utils/api";

type BookingStatus = "pending" | "confirmed" | "cancelled" | "completed";

export type Booking = {
  id: string;
  date: string;
  time: string;
  trainer?: { name?: string };
  status: BookingStatus;
  notes?: string;
};

async function fetchBookings(): Promise<Booking[]> {
  return api.get<Booking[]>("/api/user/bookings");
}

const MyBookings: React.FC = () => {
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    fetchBookings()
      .then((b) => {
        setBookings(b);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchBookings()
      .then((b) => {
        setBookings(b);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="fp-section">
      <h2>My Bookings</h2>
      {loading && <p className="muted">Loading bookings...</p>}
      {!loading && bookings.length === 0 && (
        <div className="fp-empty-state">
          No bookings scheduled. Book a 1:1 session with your trainer!
        </div>
      )}
      {!loading && bookings.length > 0 && (
        <div className="fp-bookings-list">
          {bookings.map((b) => (
            <BookingCard key={b.id} booking={b} onRefresh={refresh} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyBookings;
